/* istanbul ignore file */
import React, { useEffect } from 'react';
import { Redirect, Switch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ProgressSpinner from '@avtechsoftware/react-component-library/src/components/common/ProgressSpinner';
import NotificationGroupListLayout
  from '../../../alert_actions/notificationGroups/NotificationGroupListLayout/NotificationGroupListLayout';
import NotificationGroupFormWrapper
  from '../../../alert_actions/notificationGroups/NotificationGroupForm/NotificationGroupFormWrapper';
import NotificationTemplatesPage from '../../../alert_actions/notification_templates/NotificationTemplatesPage';
import QuietTimesPage from '../QuietTimesPage/QuietTimesPage';
import {
  fetchScrubbedUsers,
  selectUserListCrudStatus,
  selectUsersLoading,
} from '../../../../redux/slices/userListSlice/userListSlice';
import { CrudStatus } from '../../../../utility/types/CrudStatus';
import RaaRoute from '../../../common/RaaRoute';

function ActionsPage() {
  const dispatch = useDispatch();
  const userListCrudStatus = useSelector(selectUserListCrudStatus);

  useEffect(() => {
    if (userListCrudStatus === CrudStatus.IDLE) {
      dispatch(fetchScrubbedUsers());
    }
  }, []);

  const usersLoading = useSelector(selectUsersLoading);

  if (usersLoading) {
    return (
      <div className="row d-flex justify-content-center mt-5">
        <div><ProgressSpinner progressText="Loading..." /></div>
      </div>
    );
  }
  return (
    <Switch>
      <RaaRoute path="/s/actions" exact>
        <Redirect to="/s/actions/notification-groups" />
      </RaaRoute>
      <RaaRoute path="/s/actions/notification-groups" exact>
        <NotificationGroupListLayout />
      </RaaRoute>
      <RaaRoute path="/s/actions/quiet-times">
        <QuietTimesPage />
      </RaaRoute>
      <RaaRoute path="/s/actions/notification-templates">
        <NotificationTemplatesPage />
      </RaaRoute>
      <RaaRoute path="/s/actions/notification-groups/new" exact>
        <NotificationGroupFormWrapper />
      </RaaRoute>
      <RaaRoute
        path="/s/actions/notification-groups/edit/:notificationGroupId"
        exact
        render={(routeProps) => {
          const { match: actionMatch } = routeProps;
          const notificationGroupId = parseInt(actionMatch.params.notificationGroupId, 10);
          return <NotificationGroupFormWrapper notificationGroupId={notificationGroupId} />;
        }}
      />
      <RaaRoute
        path="/s/actions/notification-groups/new/:notificationGroupId"
        exact
        render={(routeProps) => {
          const { match: actionMatch } = routeProps;
          const notificationGroupId = parseInt(actionMatch.params.notificationGroupId, 10);
          return <NotificationGroupFormWrapper notificationGroupId={notificationGroupId} clone />;
        }}
      />
    </Switch>
  );
}

export default ActionsPage;
